<div class="row">
      <div class="col-sm-12 col-md-8">
        <h5 class="name">
          <span class="item-id labeled">{{registryIdLabel}}<span class="number">{{id || 'N/A'}}</span></span>
          {{fullName||"N/A"}}
        </h5>
        <ul class="styled-list title-list no-slashes">
          <li>
            <span class="info">
              <i class="fa fa-light fa-envelope" aria-hidden="true"></i>
              Email<span>
                {{email||"N/A"}}
              </span>
            </span>
          </li>
          <!--Paid Status-->
          <li *ngIf="hasPaid!==undefined && hasPaid">
            <span class="info">
              <i class="fa fa-light fa-file-invoice-dollar" aria-hidden="true"></i>Payment Status<span><i class="fa fa-circle-check success-status" aria-hidden="true"></i>Paid</span>
            </span>
          </li>
          <!--Unpaid Status-->
          <li *ngIf="hasPaid!==undefined && !hasPaid">
            <span class="info">
              <i class="fa fa-light fa-file-invoice-dollar" aria-hidden="true"></i>Payment Status<span><i class="fa fa-triangle-exclamation warning-status" aria-hidden="true"></i>Unpaid</span>
            </span>
          </li>
        </ul>
      </div>
        <div class="col-sm-12 col-md-4" *ngIf="canVerifyAttendee">
            <div class="checkbox-Switch" (click)="onVerifyClick()">
                <span>Verified Attendance</span>
                <input id="attendeeid_{{id}}" [checked]="isVerified" disabled name="verify_attendance"
                    type="checkbox" data-testid="5FB336AB-3500-4422-97C1-B9E2D45A470C" />
                <label for="attendeeid_{{id}}" class="label-success">Verify Attendance</label>
            </div>
        </div>
    </div>
